// src/pages/client/CVtheque.jsx
import React, { useState, useEffect } from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import CalltoAction from '../../components/client/CalltoAction';
import { Link } from 'react-router-dom';

const Evaluation = () => {
  const [animationStep, setAnimationStep] = useState(0);
  const [currentRating, setCurrentRating] = useState(0);
  const [showNote, setShowNote] = useState(false);
  const [typewriterText, setTypewriterText] = useState(['', '', '']);

  const noteTexts = [
    "✓ Excellent profil technique React/Node.js",
    "✓ Motivé, disponible dans 1 mois",
    "✓ Salaire: 55k€ - Compatible budget"
  ];

  // Animation séquentielle
  useEffect(() => {
    const timer = setInterval(() => {
      setAnimationStep((prev) => {
        if (prev >= 2) {
          return 0; // Restart l'animation
        }
        return prev + 1;
      });
    }, 1500);

    return () => clearInterval(timer);
  }, []);

  // Animation des étoiles
  useEffect(() => {
    if (animationStep === 0) {
      let rating = 0;
      const starTimer = setInterval(() => {
        rating += 1;
        setCurrentRating(rating);
        if (rating >= 4) {
          clearInterval(starTimer);
        }
      }, 150);
      return () => clearInterval(starTimer);
    }
  }, [animationStep]);

  // Animation de la note avec effet typewriter
  useEffect(() => {
    if (animationStep === 1) {
      setShowNote(true);
      
      // Reset du texte
      setTypewriterText(['', '', '']);
      
      // Animation typewriter pour chaque ligne
      noteTexts.forEach((fullText, lineIndex) => {
        let charIndex = 0;
        const typeTimer = setInterval(() => {
          if (charIndex <= fullText.length) {
            setTypewriterText(prev => {
              const newText = [...prev];
              newText[lineIndex] = fullText.substring(0, charIndex);
              return newText;
            });
            charIndex++;
          } else {
            clearInterval(typeTimer);
          }
        }, 50 + lineIndex * 1000); // Délai différent pour chaque ligne
      });
    } else {
      setShowNote(false);
      setTypewriterText(['', '', '']);
    }
  }, [animationStep]);

  const EvaluationSystemIllustration = () => (
    <div className="w-full max-w-xl mx-auto">
      <svg 
        viewBox="0 0 500 300" 
        className="w-full h-auto drop-shadow-xl"
      >
        {/* Background Card */}
        <rect width="500" height="300" rx="16" fill="white" stroke="#e2e8f0" strokeWidth="2" />
        
        <defs>
          <clipPath id="profileClip">
            <circle cx="80" cy="80" r="25" />
          </clipPath>
        </defs>
        
        {/* Profile Section - Photo de profil */}
        {/* Placeholder pour photo de profil - à remplacer par votre image */}
        <circle cx="80" cy="80" r="25" fill="#f1f5f9" stroke="#e2e8f0" strokeWidth="2" />
        <image 
          href="" 
          x="55" 
          y="55" 
          width="50" 
          height="50" 
          clipPath="url(#profileClip)"
          className="opacity-0"
        />
        {/* Fallback avatar icon */}
        <circle cx="80" cy="75" r="8" fill="#94a3b8" />
        <path d="M 72 88 Q 80 92 88 88" stroke="#94a3b8" strokeWidth="2" fill="none" />
        
        {/* Candidate Name - Texte réel */}
        <text x="120" y="75" fontSize="16" fontWeight="bold" fill="#1e293b">Jean Dupont</text>
        <text x="120" y="92" fontSize="12" fill="#64748b">Développeur Full Stack</text>
        
        {/* Star Rating - Toujours visible */}
        <g>
          {[1, 2, 3, 4, 5].map((star) => (
            <path
              key={star}
              d={`M ${280 + star * 25} 65 L ${283 + star * 25} 72 L ${290 + star * 25} 72 L ${285 + star * 25} 77 L ${287 + star * 25} 84 L ${280 + star * 25} 80 L ${273 + star * 25} 84 L ${275 + star * 25} 77 L ${270 + star * 25} 72 L ${277 + star * 25} 72 Z`}
              fill={currentRating >= star ? "#fbbf24" : "#e5e7eb"}
              className={`transition-all duration-300 ${currentRating >= star ? 'scale-110' : 'scale-100'}`}
              style={{
                transformOrigin: `${280 + star * 25}px 75px`
              }}
            />
          ))}
          <text x="280" y="105" fontSize="12" fill="#f59e0b" fontWeight="bold">4/5</text>
        </g>
        
        {/* Notes Section - Toujours visible */}
        <g>
          <rect x="30" y="140" width="440" height="120" rx="8" fill="#f0f9ff" stroke="#0ea5e9" strokeWidth="1" />
          <text x="45" y="160" fontSize="14" fontWeight="bold" fill="#0c4a6e">Notes</text>
          
          <rect x="45" y="170" width="410" height="20" rx="3" fill="white" />
          <text x="50" y="183" fontSize="11" fill="#374151">
            {showNote ? "✓ Excellent profil technique React/Node.js" : ""}
          </text>
          
          <rect x="45" y="200" width="410" height="20" rx="3" fill="white" />
          <text x="50" y="213" fontSize="11" fill="#374151">
            {showNote ? "✓ Motivé, disponible dans 1 mois" : ""}
          </text>
          
          <rect x="45" y="230" width="410" height="20" rx="3" fill="white" />
          <text x="50" y="243" fontSize="11" fill="#374151">
            {showNote ? "✓ Salaire: 55k€ - Compatible budget" : ""}
          </text>
        </g>
        
        {/* Action Button - Toujours visible */}
        <rect x="350" y="270" width="120" height="25" rx="6" fill="#10b981" />
        <text x="410" y="285" fontSize="12" fontWeight="bold" fill="white" textAnchor="middle">Valider</text>
      </svg>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />

      {/* Section Hero avec texte à gauche et illustration à droite */}
      <div className="py-16 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Texte à gauche */}
            <div className='text-white'>
              <div className='mb-6'>
                  <h1 className="text-5xl font-bold mb-6 leading-tight">
                    Système d'Évaluation
                 </h1>
              </div>
              <div className=' mb-8 '>
                <p className="text-xl leading-relaxed">
                Notez et évaluez vos candidats avec un système de scoring avancé pour prendre les meilleures décisions de recrutement
              </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/contact'>
                 <button className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition">
                  Commencer gratuitement
                </button>
                </Link>
              </div>
            </div>
            
            {/* Illustration animée */}
            <div className="flex justify-center">
              <EvaluationSystemIllustration />
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800">
              Fonctionnalités Principales
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Une solution complète pour évaluer et noter efficacement vos candidats
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-yellow-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Système d'Étoiles</h3>
              <p className="text-slate-600">
                Attribuez une note de 1 à 5 étoiles à chaque candidat pour évaluer rapidement leur potentiel et leur adéquation au poste.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Prise de Notes</h3>
              <p className="text-slate-600">
                Documentez vos entretiens et appels de qualification avec des notes détaillées pour garder une trace de chaque interaction.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Suivi Personnalisé</h3>
              <p className="text-slate-600">
                Historique complet des évaluations et notes pour chaque candidat, facilitant la prise de décision et le suivi dans le temps.
              </p>              
            </div>
          </div>

          <CalltoAction/>
        </div>
      </div>

      <Footer />
      
      {/* Styles pour les animations */}
      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }
      `}</style>
    </div>
  );
};

export default Evaluation;